module.exports = __webpack_public_path__ + "img/icon_menu_graduation_certification_hover.1db85472.svg";